import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ITenant } from './tenant';
import { TenantService } from './tenant.service';

@Injectable({
  providedIn: 'root'
})
export class TenantResolver  {
  constructor(
    private tenantSerivce : TenantService
  ){}

  resolve(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): Observable<ITenant[]> {
    return this.tenantSerivce.listTenants();
  }
}
